import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { produce } from 'immer'

import { PdcState, PdcStateItem, Position } from '../model/pdc'

const initialState: PdcState = {
  error: undefined,
  isLoading: false,
  pdcItem: undefined,
}

const pdcSlice = createSlice({
  initialState,
  name: 'pdc',
  reducers: {
    fetchPdcItem: {
      prepare: (id?: string, at?: Position) => {
        return { payload: { at, id } }
      },
      reducer: (state: PdcState) => {
        return produce(state, (draft) => {
          draft.isLoading = true
        })
      },
    },
    setError(state: PdcState, action: PayloadAction<string | undefined>) {
      return produce(state, (draft) => {
        draft.error = action.payload
      })
    },
    setPdcItem(state: PdcState, action: PayloadAction<PdcStateItem | undefined>) {
      return produce(state, (draft) => {
        draft.pdcItem = action.payload
        draft.isLoading = false
      })
    },
  },
})

export const { fetchPdcItem, setPdcItem, setError } = pdcSlice.actions
export const reducer = pdcSlice.reducer
